<template>
  <div class="paypal_area">
    <div id="paypal-button-container">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PayPalButton',
  components: {
  },
  data: () => ({
    payMethod: '',
  }),
  props: {
    amount: {
      type: String || Number || Object || Array || Boolean || Function || Symbol,
    },
    pointPriceId: {
      type: String || Number,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      currentUserDetail: 'user/currentUserDetail',
    }),
  },
  async mounted() {
    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_PAYPAL_CLIENT_ID}&disable-funding=card&locale=en_US&currency=JPY`;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });

    // PayPalのSDKが読み込まれた後に実行する処理をここに記述
    this.setupPayPalButtons();
  },
  methods: {
    setupPayPalButtons() {
      window.paypal.Buttons({
        commit: false, // クレジットカードの支払いボタンを非表示にする
        onClick: (data, actions) => {
          if (this.amount === 0) {
            const modifiedDetails = {
              purchase_units: [
                {
                  payments: {
                    captures: [
                      {
                        id: `${this.currentUserDetail.id}-${new Date().getTime()}`,
                      },
                    ],
                  },
                },
              ],
              pay_id: 3,
            };
            this.$emit('payPalOnApprove', modifiedDetails);
            return actions.reject();
          }

          return actions.resolve();
        },
        createOrder: (data, actions) => actions.order.create({
          purchase_units: [{
            custom_id: this.pointPriceId,
            amount: {
              currency_code: 'JPY',
              value: this.amount,
            },
          }],
          application_context: {
            shipping_preference: 'NO_SHIPPING',
            return_url: '', // ここに意図しないURLが入っているとリダイレクトされる
            cancel_url: '', // キャンセル時のリダイレクトURLも確認
          },
        }),
        onApprove: (data, actions) => actions.order.capture().then((details) => {
          const modifiedDetails = {
            ...details,
            pay_id: 3,
            point_price_id: details.purchase_units[0].custom_id || this.pointPriceId,
          };
          this.$emit('payPalOnApprove', modifiedDetails);
        }),
        onError: () => {
          alert('An error has occurred');
        },
      }).render('#paypal-button-container');
    },
  },
};
</script>

<style lang="scss" scoped>
#paypal-button-container {
  margin: 10px auto 0;
}
</style>
